import { Divider, Group, Paper, SimpleGrid, Title } from "@mantine/core";
import { useHover } from "@mantine/hooks";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ReactNode } from "react";
import { Content } from "shared/components/global/Content";
import { useIsMobile } from "shared/hooks/useIsMobile";

export const DevtoolCard = ({
    children,
    rightSection,
    onClick,
    disabled,
}: {
    children: ReactNode;
    rightSection?: ReactNode;
    onClick?: () => void;
    disabled?: boolean;
}) => {
    const { ref, hovered } = useHover();
    return (
        <Paper
            withBorder
            style={{ transition: "box-shadow 250ms", cursor: disabled ? "not-allowed" : undefined }}
            shadow={!disabled && hovered ? "xl" : undefined}
            bg={disabled ? "gray.4" : undefined}
            radius="md"
            ref={ref}
            onClick={onClick}
        >
            <Group w="full" justify="space-between" p="xl">
                <Title order={5} c={disabled ? "dimmed" : undefined}>
                    {children}
                </Title>
                {rightSection ?? <div />}
            </Group>
        </Paper>
    );
};

/** @public */
export const Route = createFileRoute("/_auth/_dev/devtools/")({
    component: () => {
        const isMobile = useIsMobile();

        return (
            <Content h="100vh">
                <Content.Heading>
                    <Title order={1}>Support Tools</Title>
                </Content.Heading>
                <Divider />

                <SimpleGrid cols={isMobile ? 1 : 2} h="full">
                    <Link to="/devtools/message-o-matic">
                        <DevtoolCard>Message-o-Matic</DevtoolCard>
                    </Link>

                    <Link to="/devtools/manage-users">
                        <DevtoolCard>Manage Users</DevtoolCard>
                    </Link>

                    <Link to="/devtools/gql">
                        <DevtoolCard>GQL Playground</DevtoolCard>
                    </Link>

                    <Link to="/devtools/regions">
                        <DevtoolCard>GeoFilters</DevtoolCard>
                    </Link>

                    <Link to="/devtools/group-vis">
                        <DevtoolCard>Group Visualizer</DevtoolCard>
                    </Link>

                    <Link to="/devtools/topics-vis">
                        <DevtoolCard>Topic Visualizer</DevtoolCard>
                    </Link>

                    <Link to="/devtools/customer">
                        <DevtoolCard>Customer</DevtoolCard>
                    </Link>

                    <Link to="/devtools/role-o-matic">
                        <DevtoolCard>Role-o-Matic</DevtoolCard>
                    </Link>

                    <Link to="/devtools/ingest">
                        <DevtoolCard>Ingest Rules</DevtoolCard>
                    </Link>

                    <Link to="/devtools/branding">
                        <DevtoolCard>Branding</DevtoolCard>
                    </Link>

                    <Link to="/devtools/systemwide-phonenumbers">
                        <DevtoolCard>Systemwide Phone Numbers</DevtoolCard>
                    </Link>

                    <Link to="/devtools/do-not-send-list">
                        <DevtoolCard>Do Not Send List (SMS Opt Out)</DevtoolCard>
                    </Link>

                    <Link to="/devtools/user-import">
                        <DevtoolCard>User Import</DevtoolCard>
                    </Link>
                </SimpleGrid>
            </Content>
        );
    },
});
